'use strict';

var _classCallCheck = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/inherits");

var EventStore = require('orbit-db-eventstore');

var FeedIndex = require('./FeedIndex');

var FeedStore =
/*#__PURE__*/
function (_EventStore) {
  _inherits(FeedStore, _EventStore);

  function FeedStore(ipfs, id, dbname, options) {
    var _this;

    _classCallCheck(this, FeedStore);

    if (!options) options = {};
    if (!options.Index) Object.assign(options, {
      Index: FeedIndex
    });
    _this = _possibleConstructorReturn(this, _getPrototypeOf(FeedStore).call(this, ipfs, id, dbname, options));
    _this._type = 'feed';
    return _this;
  }

  _createClass(FeedStore, [{
    key: "remove",
    value: function remove(hash) {
      return this.del(hash);
    }
  }, {
    key: "del",
    value: function del(hash) {
      var operation = {
        op: 'DEL',
        key: null,
        value: hash
      };
      return this._addOperation(operation);
    }
  }]);

  return FeedStore;
}(EventStore);

module.exports = FeedStore;